module.exports = __webpack_public_path__ + "static/media/alert2.3ec6dd8b.png";